module.exports = __webpack_public_path__ + "images/RebrandedVivaEngageHeroBannerDark-6eea23b37726f9f11bce78362710fc7b.png";